import { createUseStyles } from 'react-jss'
import { phonesDown } from '../../../../../styles/const/breakpoints'

const defaultBannerColor = '#FF4B55'

export default createUseStyles({
  banner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    padding: '10px 20px',
    height: 48,
    backgroundColor: data => data.color || defaultBannerColor
  },
  bannerText: {
    marginRight: 7,
    textAlign: 'center',
    margin: '5px 0'
  },
  bannerLink: {
    color: 'white',
    marginRight: 7
  },

  [`@media screen and (${phonesDown})`]: {
    banner: {
      height: 100,
      flexDirection: 'column'
    }
  }
})
